import { memo } from "react";
import { useTranslation } from "react-i18next";
import { User } from "../../types/Types";
import {
  getMembershipLabel,
  getConnectionMembershipDisplay,
} from "../../utils/connectionUserUtils";
import {
  ProfileField,
  ProfileSection,
  profileValue,
} from "./ProfileModalFields";

interface ProfileModalYouthDetailsProps {
  selectedUser: User;
  isConnected?: boolean;
}

function ProfileModalYouthDetails({
  selectedUser,
  isConnected,
}: ProfileModalYouthDetailsProps) {
  const { t } = useTranslation();
  const np = () => t("profile.notProvidedYet");

  if (!isConnected) {
    return (
      <div className="px-3 pb-3 d-md-none">
        <ProfileSection title={t("profile.section.educationDetails")}>
          <ProfileField
            label={t("profile.label.educationLevel")}
            value={profileValue(selectedUser.universityCollege, np())}
          />
        </ProfileSection>
      </div>
    );
  }

  const membership =
    getConnectionMembershipDisplay(selectedUser) ||
    getMembershipLabel(selectedUser.membershipName ?? "");

  return (
    <div className="px-3 pb-3">
      <ProfileSection title={t("profile.section.educationDetails")}>
        <ProfileField
          label={t("profile.label.educationLevel")}
          value={profileValue(selectedUser.educationLevel, np())}
        />
        <ProfileField
          label={t("profile.label.membershipTypeLower")}
          value={profileValue(membership, np())}
        />
        <ProfileField
          label={t("profile.label.skillsExperience")}
          value={profileValue(selectedUser.skillsExperience, np())}
          fullWidth
        />
        <ProfileField
          label={t("profile.label.peerNetworking")}
          value={profileValue(selectedUser.peerNetworking, np())}
        />
        <ProfileField
          label={t("profile.label.about")}
          value={profileValue(selectedUser.aboutYou, np())}
          fullWidth
        />
      </ProfileSection>
    </div>
  );
}

export default memo(ProfileModalYouthDetails);
